import { render, staticRenderFns } from "./SurgeryPatientHistory.vue?vue&type=template&id=c3ce10d4&scoped=true"
import script from "./SurgeryPatientHistory.vue?vue&type=script&lang=js"
export * from "./SurgeryPatientHistory.vue?vue&type=script&lang=js"
import style0 from "./SurgeryPatientHistory.vue?vue&type=style&index=0&id=c3ce10d4&prod&scoped=true&lang=css"
import style1 from "./SurgeryPatientHistory.vue?vue&type=style&index=1&id=c3ce10d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ce10d4",
  null
  
)

export default component.exports